/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import moment from "moment";
import momenttimezone from 'moment-timezone';
import './manageProject.css'

const officeProcessOptions = [
  { label: "Registration apply", value: "registration_apply" },
  { label: "Approved", value: "approved" },
  { label: "2nd stage apply", value: "second_stage_apply" },
  { label: "Production date", value: "production_date" },
  {
    label: "Production before registration",
    value: "production_before_registration",
  },
  { label: "Sanction pending", value: "sanction_pending" },
  { label: "Sanction done", value: "sanction_done" },
  { label: "Sanction", value: "sanction" },
];

const sanctionOptions = [
  { label: "Claim document", value: "claim_document" },
  { label: "Claim office process", value: "claim_office_process" },
  { label: "Claim submit", value: "claim_submit" },
  { label: "Claim approved", value: "claim_approved" },
  { label: "Fund received", value: "fund_received" },
];

const offlineOption = [
  { label: "Physical file inward", value: "physicalFileInward" },
  { label: "Inward number and Inward date", value: "inwardNoDate" },
  { label: "SGST Inward number and date", value: "sgstInwardNoDate" },
  { label: "Applying for sanction", value: "applyingForSanction" },
  { label: "Sanction status", value: "offlineSanctionStatus" },
  { label: "Claim process", value: "claimProcess" },
  { label: "Fund status", value: "fundStatus" },
];

const onlineOption = [
  { label: "Office process for sanction", value: "officeProcessForSanction" },
  { label: "DIC process for sanction", value: "dicProcessForSanction" },
  { label: "Claim", value: "claim" },
  { label: "Claim DIC process", value: "claimDicProcess" },
  { label: "Claim status", value: "claimStatus" },
];

const ManageProject = () => {
  const navigate = useNavigate();
  const [dataList, setDataList] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [projectId, setProjectId] = useState(null);
  const [selectValues, setSelectValues] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [filterText, setFilterText] = useState("");

  const [selectedCategory, setSelectedCategory] = useState({});
  const [selectedSanctionOptions, setSelectedSanctionOptions] = useState({});

  const [selected2022Policy, setSelected2022Policy] = useState({});

  const handle2019PolicyChange = async (id, fieldName, value) => {
    const updatedData = [...dataList];
    const rowIndex = dataList.findIndex((item) => item.id === id);

    if (fieldName === "status4") {
      setSelectedCategory((prev) => ({ ...prev, [id]: value }));
      updatedData[rowIndex][fieldName] = value;

      if (value !== "sanction") {
        setSelectedSanctionOptions((prev) => ({ ...prev, [id]: "" }));
        updatedData[rowIndex]["sanctionStatus"] = null;
      }
    } else if (fieldName === "sanctionStatus") {
      setSelectedSanctionOptions((prev) => ({ ...prev, [id]: value }));
      updatedData[rowIndex][fieldName] = value;
    }
    setDataList(updatedData);
  };

  const handleUpdateClick = async (id) => {
    try {
      const updatedData = [...dataList];
      const rowIndex = updatedData.findIndex((item) => item.id === id);

      const status4Value =
        selectedCategory[id] || updatedData[rowIndex]?.status4 || "";
      const sanctionStatusValue =
        selectedSanctionOptions[id] ||
        updatedData[rowIndex]?.sanctionStatus ||
        "";

      const editCategoryOption = await axios.put(
        `${process.env.REACT_APP_API_URL}/update-project/${id}`,
        {
          status4: status4Value,
          sanctionStatus: sanctionStatusValue,
        }
      );

      if (editCategoryOption.status === 200) {
        updatedData[rowIndex].status4 = status4Value;
        updatedData[rowIndex].sanctionStatus = sanctionStatusValue;
        setDataList(updatedData);

        toast.success(editCategoryOption.data.message);
      }
    } catch (error) {
      console.error("Error updating status", error);
    }
  };

  const handle2022PolicyChange = (e, id, fieldName) => {
    const newValue = e.target.value;

    const updatedData = [...dataList];
    const rowIndex = dataList.findIndex((item) => item.id === id);

    setSelected2022Policy((prev) => ({
      ...prev,
      [id]: { ...prev[id], [fieldName]: newValue },
    }));
    updatedData[rowIndex][fieldName] = newValue;

    if (fieldName === "status5" && newValue === "online") {
      updatedData[rowIndex]["offlineOption"] = null;
      setSelected2022Policy((prev) => ({
        ...prev,
        [id]: { ...prev[id], offlineOption: "" },
      }));
    } else if (fieldName === "status5" && newValue === "offline") {
      updatedData[rowIndex]["onlineOption"] = null;
      setSelected2022Policy((prev) => ({
        ...prev,
        [id]: { ...prev[id], onlineOption: "" },
      }));
    }

    setDataList(updatedData);
  };

  const handleSaveChanges = async () => {
    const updates = Object.entries(selected2022Policy).map(([id, changes]) => ({
      id,
      ...changes,
    }));

    try {
      const responses = await Promise.all(
        updates.map((update) =>
          axios.put(
            `${process.env.REACT_APP_API_URL}/update-project/${update.id}`,
            update
          )
        )
      );

      if (responses.every((res) => res.status === 200)) {
        toast.success("Project has been updated successfully.");
        setSelected2022Policy({});
      }
    } catch (error) {
      console.error("Error updating status", error);
      toast.error("An error occurred while updating the data.");
    }
  };

  const calculateAge = (dob) => {
    if (!dob) {
      return "";
    }
    const birthDate = moment(dob);
    const currentDate = moment();
    const age = currentDate.diff(birthDate, "years");
    return age;
  };

  const handleSelectChange2 = (event, itemId, selectName) => {
    const { value } = event.target;

    setSelectValues((prevValues) => ({
      ...prevValues,
      [itemId]: {
        ...prevValues[itemId],
        [selectName]: value,
      },
    }));
  };

  const handleSaveStatus = async (itemId) => {
    const selectedValues = selectValues[itemId];

    if (!selectedValues) {
      toast.error("No changes to save.");
      return;
    }

    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}/update-project/${itemId}`,
        selectedValues
      );

      if (response.status === 200) {
        setDataList((prevDataList) =>
          prevDataList.map((item) =>
            item.id === itemId ? { ...item, ...selectedValues } : item
          )
        );
        setSelectValues((prevValues) => {
          const newValues = { ...prevValues };
          delete newValues[itemId];
          return newValues;
        });
        toast.success("Project has been updated successfully.");
      }
    } catch (error) {
      console.error("API error:", error);
      toast.error("An error occurred while updating the data.");
    }
  };

  const handleInputChange = (e, itemId, selectName) => {
    const inputValue = e.target.value;
    const updatedSelectValues = {
      ...selectValues,
      [itemId]: {
        ...selectValues[itemId],
        [selectName]: inputValue,
      },
    };
    setSelectValues(updatedSelectValues);
    // setProjectId(itemId);
    e.target.value = "";
  };

  const callApi = (itemId, selectedValues) => {
    const apiUrl = `${process.env.REACT_APP_API_URL}/update-project/${itemId}`;

    axios
      .put(apiUrl, selectedValues)
      .then((response) => {
        if (response.status === 200) {
          setSelectValues({});
          setProjectId(null);
          toast.success(response.data.message);
          handleData();
        }
      })
      .catch((error) => {
        console.error("API error:", error);
      });
  };
  const handleOpenModal = (id) => {
    setIsModalOpen(true);
    setProjectId(id);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleDeleteProject = async () => {
    const confirmDelete = window.confirm("Are you sure you want to delete this project?");
    if (!confirmDelete) {
      return; // Exit the function if the user cancels the delete action
    }
  
    try {
      await axios
        .delete(
          `${process.env.REACT_APP_API_URL}/delete-project/${projectId}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("signIn")}`,
            },
          }
        )
        .then((res) => {
          if (res.status === 200) {
            setIsModalOpen(false);
            handleData();
            toast.success(res.data.message);
          }
        });
    } catch (error) {
      if (error.response && error.response.status === 500) {
        toast.error("This project is not deleted");
      } else {
        toast.error("An error occurred. Please try again.");
      }
    }
  };
  
  const handleEditClick = (value) => {
    navigate("/", {
      state: {
        editMode: true,
        projectId: value?.id,
        clientId: value.client_Id,
      },
    });
  };
  const handleData = async () => {
    try {
      const projectResponse = await axios.get(
        `${process.env.REACT_APP_API_URL}/get-all-project?search=${filterText}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("signIn")}`,
          },
        }
      );

      const projects = projectResponse.data.result;
      if (projects && projects.length > 0) {
        setDataList(projects);
      } else {
        console.log("No records available.");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    if (value.trim() === "") {
      setFilterText("");
    }
  };

  const handleSearchClick = () => {
    setFilterText(searchTerm);
  };

  // useEffect(() => {
  //   const selectedValues = selectValues[projectId];
  //   if (selectedValues || projectId) {
  //     callApi(projectId, selectedValues);
  //   }
  // }, [selectValues, projectId]);

  useEffect(() => {
    handleData();
  }, [filterText]);

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleSearchClick();
    }
  };
  useEffect(() => {
    console.log("datalist", dataList);
  }, [dataList]);
  const formatTime = (dateString, from) => {
    const updatedAt = momenttimezone(dateString).tz('Asia/Kolkata');
    if(from == "date"){
      return updatedAt.format('DD-MM-YYYY');
    }else{
      return updatedAt.format('HH:mm:ss');
    }
  };
  return (
    <div id="main" className="main">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <h2 style={{ flex: "1", marginLeft: "15px" }}>Project Master</h2>
        <div className="search-wrapper">
          <input
            className="form-control me-2"
            type="search"
            value={searchTerm}
            onChange={handleChange}          
            onKeyPress={handleKeyPress}  
            placeholder="Search projects, key persons, clients..."
          />
          <button className="btn btn-dark me-2" onClick={handleSearchClick}>
            Search
          </button>
        </div>
        <button
          className="btn btn-dark"
          style={{ marginRight: "17px" }}
          onClick={() => {
            navigate("/");
          }}
        >
          <i className="bi bi-plus-lg"></i> Add
        </button>
      </div>

      <div className="col-lg-12">
        <div className="card mb-8">
          <div className="card-body">
            <div className="table-responsive table-wrapper" style={{maxHeight: '70vh'}}>
              <table
                id="data-table"
                className="table table-bordered table-hover"
              >
                <thead>
                  <tr className="t-header">
                    <th>Action</th>
                    <th>Sr No</th>
                    <th className="fixed-column">File No</th>
                    <th>ORIGINAL BILL</th>
                    <th>Firm Name</th>
                    <th>Contact Person</th>
                    <th>Contact No</th>
                    <th>Bank & Branch</th>
                    <th>Loan A/C No</th>
                    <th>Current A/C No</th>
                    <th>Loan Amount</th>
                    <th>Sanction Date</th>
                    <th>Disb Date</th>
                    <th>Production Date</th>
                    <th>1st Registration</th>
                    <th>Type of Activity</th>
                    <th>New Expansion</th>
                    <th>Cost Project</th>
                    <th>SC ST General</th>
                    <th>Urban/Rural</th>
                    <th>Male Female</th>
                    <th>DOB</th>
                    <th>Age</th>
                    <th>Owned Rented</th>
                    <th>Central</th>
                    <th>Amount</th>
                    <th>State Capital</th>
                    <th>Amount</th>
                    <th>CGTSME</th>
                    <th>CGTSME Amt.</th>
                    <th>CGPAN No.</th>
                    {/* <th>Status</th> */}
                    <th>Status</th>
                    <th>Claim Period</th>
                    <th>Claim Amount Received From Dept.</th>
                    <th>Fund Status</th>
                    <th>Fees Recovery Status</th>
                    {/* <th>Status</th> */}
                    {/* <th>Status</th> */}
                    {/* <th>Office Process</th> */}
                    {/* <th>DIC SUB Stage</th>
                    <th>Power Sub</th> */}
                    {/* <th>STATUS</th> */}
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {dataList
                    ?.slice()
                    .sort((a, b) => a.id - b.id)
                    .map((value, index) => (
                      <tr key={index}>
                        <td>
                          <a
                            style={{ marginRight: "8px", cursor: "pointer" }}
                            onClick={() => handleOpenModal(value?.id)}
                          >
                            <i className="bi bi-trash3"></i>
                          </a>
                          <a
                            style={{ cursor: "pointer" }}
                            onClick={() => handleEditClick(value)}
                          >
                            <i className="bi bi-pencil"></i>
                          </a>
                        </td>
                        <td>{index + 1}</td>
                        <td className="fixed-column">
                          {(value?.nameFirm
                            ?.split(" ")
                            .map((val) => (val[0] ? val[0]?.toUpperCase() : ""))
                            .join("") || "") + value?.id || ""}
                        </td>
                        <td>DONE</td>
                        <td>{value?.nameFirm}</td>
                        <td>{value?.nameOfKey}</td>
                        <td>{value?.contact}</td>
                        <td>{value?.bankName + " " + value?.bankBranch}</td>
                        <td>{value?.loanAcc}</td>
                        <td>{value?.currentAccNo}</td>
                        <td>{value?.loanAmt}</td>
                        <td>
                          {moment(value?.loanSanction).format("DD/MM/YYYY")}
                        </td>
                        <td>
                          {moment(value?.loanDisbursed).format("DD/MM/YYYY")}
                        </td>
                        <td>{moment(value?.dateCom).format("DD/MM/YYYY")}</td>
                        <td>
                          {moment(value?.firstRegistration).isValid()
                            ? moment(value?.firstRegistration).format(
                                "DD/MM/YYYY"
                              )
                            : ""}
                        </td>
                        <td>
                          {value?.activityType &&
                            JSON.parse(value?.activityType).map(
                              (val, index) => <p key={index}>{val}</p>
                            )}
                        </td>
                        <td>{value?.projectType}</td>
                        <td>{value?.costProject}</td>
                        <td>
                          {value?.ownerCategories && (
                            <div>
                              {value?.ownerCategories
                                .split(",")
                                .map((category, index) => (
                                  <p key={index}>{category}</p>
                                ))}
                            </div>
                          )}
                        </td>
                        <td>
                          {value?.addCategory === "category_1" ||
                          value?.addCategory === "category_2"
                            ? "Urban"
                            : value?.addCategory === "category_3"
                            ? "Rural"
                            : ""}
                        </td>
                        <td>
                          {value?.ownerGenders && (
                            <div>
                              {value?.ownerGenders
                                .split(",")
                                .map((gender, index) => (
                                  <p key={index}>{gender}</p>
                                ))}
                            </div>
                          )}
                        </td>
                        <td>
                          {value?.ownerDobs && (
                            <div>
                              {value?.ownerDobs
                                .split(",")
                                .reverse()
                                .map((dob, index) => (
                                  <p key={index}>
                                    {moment(dob).isValid()
                                      ? moment(dob).format("DD/MM/YYYY")
                                      : ""}
                                  </p>
                                ))}
                            </div>
                          )}
                        </td>
                        <td>
                          {value?.ownerDobs && (
                            <div>
                              {value?.ownerDobs
                                .split(",")
                                .reverse()
                                .map((dob, index) => (
                                  <p key={index}>{calculateAge(dob)}</p>
                                ))}
                            </div>
                          )}
                        </td>
                        <td>{value?.occupancyType}</td>
                        <td>
                          <input
                            type="text"
                            value={
                              selectValues[value?.id]?.central ||
                              value?.central ||
                              ""
                            }
                            onChange={(e) => {
                              handleInputChange(e, value?.id, "central");
                            }}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                handleInputChange(e, value?.id, "central");
                                callApi(
                                  value?.id,
                                  selectValues[value?.id],
                                  "central"
                                );
                              }
                            }}
                          />
                          <button onClick={() => handleSaveStatus(value?.id)}>
                              <i className="bi bi-check2" />
                          </button>
                        </td>
                        <td>
                          <input
                            type="number"
                            value={
                              selectValues[value?.id]?.amount1 ||
                              value?.amount1 ||
                              ""
                            }
                            onChange={(e) => {
                              handleInputChange(e, value?.id, "amount1");
                            }}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                handleInputChange(e, value?.id, "amount1");
                                callApi(
                                  value?.id,
                                  selectValues[value?.id],
                                  "amount1"
                                );
                              }
                            }}
                          />
                          <button onClick={() => handleSaveStatus(value?.id)}>
                              <i className="bi bi-check2" />
                          </button>
                        </td>
                        <td>{`${value?.capital2019 || ""} ${
                          value?.capital2020 || ""
                        } ${value?.capital2022 || ""}`}</td>
                        <td>
                          <input
                            type="number"
                            value={
                              selectValues[value?.id]?.amount2 ||
                              value?.amount2 ||
                              ""
                            }
                            onChange={(e) => {
                              handleInputChange(e, value?.id, "amount2");
                            }}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                handleInputChange(e, value?.id, "amount2");
                                callApi(
                                  value?.id,
                                  selectValues[value?.id],
                                  "amount2"
                                );
                              }
                            }}
                          />
                        </td>
                        <td>{value?.cgtmse}</td>
                        <td>{value?.cgtmseCharges}</td>
                        <td>
                          <div className="d-flex align-items-center gap-2">
                            <input
                              type="text"
                              value={
                                selectValues[value?.id]?.cgpan ||
                                value?.cgpan ||
                                ""
                              }
                              onChange={(e) => {
                                handleInputChange(e, value?.id, "cgpan");
                              }}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  handleInputChange(e, value?.id, "cgpan");
                                  callApi(
                                    value?.id,
                                    selectValues[value?.id],
                                    "cgpan"
                                  );
                                }
                              }}
                            />
                            <button onClick={() => handleSaveStatus(value?.id)}>
                              <i className="bi bi-check2" />
                            </button>
                          </div>
                        </td>
                        {/* <td>
                          <div className="d-flex flex-column mb-4 gap-2">
                            <label htmlFor={`category-${value.id}`}>
                              Office Process Option:
                            </label>
                            <select
                              id={`category-${value.id}`}
                              value={
                                selectedCategory[value.id] ||
                                value?.status4 ||
                                ""
                              }
                              onChange={(e) => {
                                handle2019PolicyChange(
                                  value?.id,
                                  "status4",
                                  e.target.value
                                );
                              }}
                            >
                              <option value="">Select</option>
                              {officeProcessOptions?.map((category) => (
                                <option
                                  key={category.value}
                                  value={category.value}
                                >
                                  {category.label}
                                </option>
                              ))}
                            </select>

                            {(selectedCategory[value.id] === "sanction" ||
                              value.status4 === "sanction") && (
                              <div>
                                <label htmlFor={`sanctionOption-${value.id}`}>
                                  Sanction Options:
                                </label>
                                <select
                                  id={`sanctionOption-${value.id}`}
                                  value={
                                    selectedSanctionOptions[value.id] ||
                                    value.sanctionStatus ||
                                    ""
                                  }
                                  onChange={(e) => {
                                    handle2019PolicyChange(
                                      value?.id,
                                      "sanctionStatus",
                                      e.target.value
                                    );
                                  }}
                                >
                                  <option value="">Select Option</option>
                                  {sanctionOptions.map((option) => (
                                    <option
                                      key={option.value}
                                      value={option.value}
                                    >
                                      {option.label}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            )}

                            <button
                              onClick={() => {
                                handleUpdateClick(value?.id);
                              }}
                              style={{ width: "fit-content" }}
                            >
                              <i className="bi bi-check2" />
                            </button>
                          </div>
                        </td> */}
                        <td>
                          <div className="d-flex flex-column mb-4 gap-2">
                            <select
                              value={
                                selected2022Policy[value?.id]?.status5 ||
                                value?.status5 ||
                                ""
                              }
                              onChange={(e) => {
                                handle2022PolicyChange(e, value?.id, "status5");
                              }}
                            >
                              <option value="">Select</option>
                              <option value="offline">Offline</option>
                              <option value="online">Online</option>
                            </select>

                            {(selected2022Policy[value.id]?.status5 ===
                              "offline" ||
                              value.status5 === "offline") && (
                              <div>
                                <label>Offline Options:</label>
                                <select
                                  id={`offlineOption-${value.id}`}
                                  value={
                                    selected2022Policy[value.id]
                                      ?.offlineOption ||
                                    value.offlineOption ||
                                    ""
                                  }
                                  onChange={(e) => {
                                    handle2022PolicyChange(
                                      e,
                                      value?.id,
                                      "offlineOption"
                                    );
                                  }}
                                >
                                  <option value="">Select Option</option>
                                  {offlineOption.map((option) => (
                                    <option
                                      key={option.value}
                                      value={option.value}
                                    >
                                      {option.label}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            )}
                            {((selected2022Policy[value.id]?.status5 ===
                              "offline" &&
                              selected2022Policy[value.id]?.offlineOption ===
                                "physicalFileInward") ||
                              value.offlineOption === "physicalFileInward") && (
                              <select
                                id={`physicalFileInward-${value.id}`}
                                value={
                                  selected2022Policy[value.id]
                                    ?.physicalFileInward ||
                                  value.physicalFileInward ||
                                  ""
                                }
                                onChange={(e) => {
                                  handle2022PolicyChange(
                                    e,
                                    value?.id,
                                    "physicalFileInward"
                                  );
                                }}
                              >
                                <option value="">Select Option</option>
                                <option value="yes">Yes</option>
                                <option value="no">No</option>
                              </select>
                            )}
                            {((selected2022Policy[value.id]?.status5 ===
                              "offline" &&
                              selected2022Policy[value.id]?.offlineOption ===
                                "inwardNoDate") ||
                              value.offlineOption === "inwardNoDate") && (
                              <select
                                id={`inwardNoDate-${value.id}`}
                                value={
                                  selected2022Policy[value.id]?.inwardNoDate ||
                                  value.inwardNoDate ||
                                  ""
                                }
                                onChange={(e) => {
                                  handle2022PolicyChange(
                                    e,
                                    value?.id,
                                    "inwardNoDate"
                                  );
                                }}
                              >
                                <option value="">Select Option</option>
                                <option value="capital">Capital</option>
                              </select>
                            )}
                            {((selected2022Policy[value.id]?.status5 ===
                              "offline" &&
                              selected2022Policy[value.id]?.offlineOption ===
                                "sgstInwardNoDate") ||
                              value.offlineOption === "sgstInwardNoDate") && (
                              <select
                                id={`sgstInwardNoDate-${value.id}`}
                                value={
                                  selected2022Policy[value.id]
                                    ?.sgstInwardNoDate ||
                                  value.sgstInwardNoDate ||
                                  ""
                                }
                                onChange={(e) => {
                                  handle2022PolicyChange(
                                    e,
                                    value?.id,
                                    "sgstInwardNoDate"
                                  );
                                }}
                              >
                                <option value="">Select Option</option>
                                <option value="sgst">SGST</option>
                              </select>
                            )}
                            {((selected2022Policy[value.id]?.status5 ===
                              "offline" &&
                              selected2022Policy[value.id]?.offlineOption ===
                                "applyingForSanction") ||
                              value.offlineOption ===
                                "applyingForSanction") && (
                              <select
                                id={`applyingForSanction-${value.id}`}
                                value={
                                  selected2022Policy[value.id]
                                    ?.applyingForSanction ||
                                  value.applyingForSanction ||
                                  ""
                                }
                                onChange={(e) => {
                                  handle2022PolicyChange(
                                    e,
                                    value?.id,
                                    "applyingForSanction"
                                  );
                                }}
                              >
                                <option value="">Select Option</option>
                                <option value="submitToClerk">
                                  Submit to clerk
                                </option>
                                <option value="clerkSign">Clerk sign</option>
                                <option value="rmSign">RM sign</option>
                                <option value="gmSign">GM sign</option>
                              </select>
                            )}
                            {((selected2022Policy[value.id]?.status5 ===
                              "offline" &&
                              selected2022Policy[value.id]?.offlineOption ===
                                "offlineSanctionStatus") ||
                              value.offlineOption ===
                                "offlineSanctionStatus") && (
                              <select
                                id={`offlineSanctionStatus-${value.id}`}
                                value={
                                  selected2022Policy[value.id]
                                    ?.offlineSanctionStatus ||
                                  value.offlineSanctionStatus ||
                                  ""
                                }
                                onChange={(e) => {
                                  handle2022PolicyChange(
                                    e,
                                    value?.id,
                                    "offlineSanctionStatus"
                                  );
                                }}
                              >
                                <option value="">Select Option</option>
                                <option value="approved">Approved</option>
                                <option value="rejected">Rejected</option>
                                <option value="needClarification">
                                  Need clarification
                                </option>
                              </select>
                            )}
                            {((selected2022Policy[value.id]?.status5 ===
                              "offline" &&
                              selected2022Policy[value.id]?.offlineOption ===
                                "claimProcess") ||
                              value.offlineOption === "claimProcess") && (
                              <select
                                id={`claimProcess-${value.id}`}
                                value={
                                  selected2022Policy[value.id]?.claimProcess ||
                                  value.claimProcess ||
                                  ""
                                }
                                onChange={(e) => {
                                  handle2022PolicyChange(
                                    e,
                                    value?.id,
                                    "claimProcess"
                                  );
                                }}
                              >
                                <option value="">Select Option</option>
                                <option value="clientDocument">
                                  Client document
                                </option>
                                <option value="bankClaim">Bank claim</option>
                                <option value="officeProcess">
                                  Office process
                                </option>
                                <option value="claimSubmit">
                                  Claim submit
                                </option>
                                <option value="inward">Inward</option>
                                <option value="inspectorAllotment">
                                  Inspector allotment
                                </option>
                                <option value="RM">RM</option>
                                <option value="GM">GM</option>
                                <option value="approved">Approved</option>
                              </select>
                            )}
                            {((selected2022Policy[value.id]?.status5 ===
                              "offline" &&
                              selected2022Policy[value.id]?.offlineOption ===
                                "fundStatus") ||
                              value.offlineOption === "fundStatus") && (
                              <select
                                id={`fundStatus-${value.id}`}
                                value={
                                  selected2022Policy[value.id]?.fundStatus ||
                                  value.fundStatus ||
                                  ""
                                }
                                onChange={(e) => {
                                  handle2022PolicyChange(
                                    e,
                                    value?.id,
                                    "fundStatus"
                                  );
                                }}
                              >
                                <option value="">Select Option</option>
                                <option value="inGrant">In grant</option>
                                <option value="fundReceived">
                                  Fund received
                                </option>
                              </select>
                            )}
                            {(selected2022Policy[value.id]?.status5 ===
                              "online" ||
                              value.status5 === "online") && (
                              <div>
                                <label>Online Options:</label>
                                <select
                                  id={`onlineOption-${value.id}`}
                                  value={
                                    selected2022Policy[value.id]
                                      ?.onlineOption ||
                                    value.onlineOption ||
                                    ""
                                  }
                                  onChange={(e) => {
                                    handle2022PolicyChange(
                                      e,
                                      value?.id,
                                      "onlineOption"
                                    );
                                  }}
                                >
                                  <option value="">Select Option</option>
                                  {onlineOption.map((option) => (
                                    <option
                                      key={option.value}
                                      value={option.value}
                                    >
                                      {option.label}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            )}
                            {((selected2022Policy[value.id]?.status5 ===
                              "online" &&
                              selected2022Policy[value.id]?.onlineOption ===
                                "officeProcessForSanction") ||
                              value.onlineOption ===
                                "officeProcessForSanction") && (
                              <select
                                id={`officeProcessForSanction-${value.id}`}
                                value={
                                  selected2022Policy[value.id]
                                    ?.officeProcessForSanction ||
                                  value.officeProcessForSanction ||
                                  ""
                                }
                                onChange={(e) => {
                                  handle2022PolicyChange(
                                    e,
                                    value?.id,
                                    "officeProcessForSanction"
                                  );
                                }}
                              >
                                <option value="">Select Option</option>
                                <option value="clientDocument">
                                  Client document
                                </option>
                                <option value="applicationSubmit">
                                  Application submit
                                </option>
                                <option value="filePrepared">
                                  File prepared
                                </option>
                              </select>
                            )}
                            {((selected2022Policy[value.id]?.status5 ===
                              "online" &&
                              selected2022Policy[value.id]?.onlineOption ===
                                "dicProcessForSanction") ||
                              value.onlineOption ===
                                "dicProcessForSanction") && (
                              <select
                                id={`dicProcessForSanction-${value.id}`}
                                value={
                                  selected2022Policy[value.id]
                                    ?.dicProcessForSanction ||
                                  value.dicProcessForSanction ||
                                  ""
                                }
                                onChange={(e) => {
                                  handle2022PolicyChange(
                                    e,
                                    value?.id,
                                    "dicProcessForSanction"
                                  );
                                }}
                              >
                                <option value="">Select Option</option>
                                <option value="submitToclerk">
                                  Submit to clerk
                                </option>
                                <option value="clerkInspection">
                                  Clerk inspection
                                </option>
                                <option value="rmInspection">
                                  RM inspection
                                </option>
                                <option value="gmInspection">
                                  GM inspection
                                </option>
                                <option value="approved">Approved</option>
                                <option value="rejected">Rejected</option>
                              </select>
                            )}
                            {((selected2022Policy[value.id]?.status5 ===
                              "online" &&
                              selected2022Policy[value.id]?.onlineOption ===
                                "claim") ||
                              value.onlineOption === "claim") && (
                              <select
                                id={`claim-${value.id}`}
                                value={
                                  selected2022Policy[value.id]?.claim ||
                                  value.claim ||
                                  ""
                                }
                                onChange={(e) => {
                                  handle2022PolicyChange(e, value?.id, "claim");
                                }}
                              >
                                <option value="">Select Option</option>
                                <option value="clientDocumentPending">
                                  Client document pending
                                </option>
                                <option value="bankClaim">Bank Claim</option>
                                <option value="onlineClaimSubmitted">
                                  Online claim submitted
                                </option>
                                <option value="filePrepared">
                                  File prepared
                                </option>
                              </select>
                            )}
                            {((selected2022Policy[value.id]?.status5 ===
                              "online" &&
                              selected2022Policy[value.id]?.onlineOption ===
                                "claimDicProcess") ||
                              value.onlineOption === "claimDicProcess") && (
                              <select
                                id={`claimDicProcess-${value.id}`}
                                value={
                                  selected2022Policy[value.id]
                                    ?.claimDicProcess ||
                                  value.claimDicProcess ||
                                  ""
                                }
                                onChange={(e) => {
                                  handle2022PolicyChange(
                                    e,
                                    value?.id,
                                    "claimDicProcess"
                                  );
                                }}
                              >
                                <option value="">Select Option</option>
                                <option value="clerkInward">
                                  Clerk inward
                                </option>
                                <option value="inspectorAllotment">
                                  Inspector allotment
                                </option>
                                <option value="forwardToRM">
                                  Forward to RM
                                </option>
                                <option value="forwardToGM">
                                  Forward to GM
                                </option>
                                <option value="approved">Approved</option>
                                <option value="rejected">Rejected</option>
                                <option value="needClarification">
                                  Need clarification
                                </option>
                              </select>
                            )}
                            {((selected2022Policy[value.id]?.status5 ===
                              "online" &&
                              selected2022Policy[value.id]?.onlineOption ===
                                "claimStatus") ||
                              value.onlineOption === "claimStatus") && (
                              <select
                                id={`claimStatus-${value.id}`}
                                value={
                                  selected2022Policy[value.id]?.claimStatus ||
                                  value.claimStatus ||
                                  ""
                                }
                                onChange={(e) => {
                                  handle2022PolicyChange(
                                    e,
                                    value?.id,
                                    "claimStatus"
                                  );
                                }}
                              >
                                <option value="">Select Option</option>
                                <option value="inGrant">In grant</option>
                                <option value="fundReceived">
                                  fund received
                                </option>
                              </select>
                            )}
                            <button
                              onClick={handleSaveChanges}
                              style={{ width: "fit-content" }}
                            >
                              <i className="bi bi-check2" />
                            </button>
                          </div>
                          Last Updated: {formatTime(value?.updatedAt, "date")} {formatTime(value?.updatedAt, "time")}
                        </td>
                        {/* Claim Period */}
                        <td>
                          <select
                            id={`claim_period`}
                            value={
                              selectValues[value?.id]?.claim_period ||
                              value?.claim_period ||
                              ""
                            }
                            onChange={(e) => {
                              handleInputChange(e, value?.id, "claim_period");
                            }}
                          >
                            <option value="">Select Option</option>
                            <option value="yearly_basis">Yearly Basis</option>
                            <option value="half_yearly">half Yearly</option>
                          </select>
                          <button
                              onClick={() => callApi(
                                value?.id,
                                selectValues[value?.id],
                                "claim_period"
                              )}
                              style={{ width: "fit-content" }}
                            >
                              <i className="bi bi-check2" />
                            </button>
                        </td>
                        {/* Claim Amount */}
                        <td>
                          <select
                              id={`claim_amount_from_dept`}
                              value={
                                selectValues[value?.id]?.claim_amount_from_dept ||
                                value?.claim_amount_from_dept ||
                                ""
                              }
                              onChange={(e) => {
                                handleInputChange(e, value?.id, "claim_amount_from_dept");
                              }}
                            >
                              <option value="">Select Option</option>
                              <option value="yes">Yes</option>
                              <option value="no">no</option>
                          </select>
                          <button
                              onClick={() => callApi(
                                value?.id,
                                selectValues[value?.id],
                                "claim_amount_from_dept"
                              )}
                              style={{ width: "fit-content" }}
                            >
                              <i className="bi bi-check2" />
                            </button>
                        </td>
                        {/* Fund Status */}
                        <td>
                          <select
                              id={`fund_status`}
                              value={
                                selectValues[value?.id]?.fund_status ||
                                value?.fund_status ||
                                ""
                              }
                              onChange={(e) => {
                                handleInputChange(e, value?.id, "fund_status");
                              }}
                            >
                              <option value="">Select Option</option>
                              <option value="office_process">Office process</option>
                              <option value="dic_allot">Dic allot</option>
                              <option value="fund_received">Fund received</option>
                              <option value="a/c_closed">A/c closed</option>
                              <option value="under_sub_amt_20000">Under sub. Amt. 20000</option>
                              <option value="hold">Hold</option>
                          </select>
                          <button
                              onClick={() => callApi(
                                value?.id,
                                selectValues[value?.id],
                                "fund_status"
                              )}
                              style={{ width: "fit-content" }}
                            >
                              <i className="bi bi-check2" />
                            </button>
                        </td>
                        {/* Fees Recovery Status */}
                        <td>
                          <div>
                            <select
                                id={`fees_recovery`}
                                value={
                                  selectValues[value?.id]?.fees_recovery ||
                                  value?.fees_recovery ||
                                  ""
                                }
                                onChange={(e) => {
                                  handleInputChange(e, value?.id, "fees_recovery");
                                }}
                              >
                                <option value="">Select Option</option>
                                <option value="yes">Yes</option>
                                <option value="no">no</option>
                            </select>
                            <button
                                onClick={() => callApi(
                                  value?.id,
                                  selectValues[value?.id],
                                  "fees_recovery"
                                )}
                                style={{ width: "fit-content" }}
                              >
                                <i className="bi bi-check2" />
                              </button>
                            </div>
                            <div>
                              <lable>Fees amount:</lable>
                              <input
                                type="number"
                                value={
                                  selectValues[value?.id]?.fees_amount ||
                                  value?.fees_amount ||
                                  ""
                                }
                                onChange={(e) => {
                                  handleInputChange(e, value?.id, "fees_amount");
                                }}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") {
                                    handleInputChange(e, value?.id, "fees_amount");
                                    callApi(
                                      value?.id,
                                      selectValues[value?.id],
                                      "fees_amount"
                                    );
                                  }
                                }}
                              />
                              <button
                                onClick={() => callApi(
                                  value?.id,
                                  selectValues[value?.id],
                                  "fees_amount"
                                )}
                                style={{ width: "fit-content" }}
                              >
                                <i className="bi bi-check2" />
                              </button>
                            </div>
                        </td>
                        {/* <td>
                          <div className="d-flex align-items-center gap-2">
                            <select
                              value={
                                selectValues[value?.id]?.status1 ||
                                value?.status1 ||
                                ""
                              }
                              onChange={(e) => {
                                handleSelectChange2(e, value?.id, "status1");
                              }}
                            >
                              <option value="">Select</option>
                              <option value="2ndStagePending">
                                2nd stage pending
                              </option>
                              <option value="claimUnderProcess">
                                Claim under process
                              </option>
                              <option value="sanctionDoneClaim">
                                Sanction done claim sub pending
                              </option>
                              <option value="sanctionDonePro">
                                Sanction done pro before reg
                              </option>
                              <option value="sanctionPending">
                                Sanction pending
                              </option>
                              <option value="sanctionPendingPro">
                                Sanction pending pro before reg
                              </option>
                            </select>
                            <button onClick={() => handleSaveStatus(value?.id)}>
                              <i className="bi bi-check2" />
                            </button>
                          </div>
                        </td> */}
                        {/* <td>
                          <div className="d-flex align-items-center gap-2">
                            <select
                              value={
                                selectValues[value?.id]?.status2 ||
                                value?.status2 ||
                                ""
                              }
                              onChange={(e) => {
                                handleSelectChange2(e, value?.id, "status2");
                              }}
                            >
                              <option value="">Select</option>
                              <option value="2ndStagePending">
                                2nd stage pending
                              </option>
                              <option value="claimUnderProcess">
                                Claim under process
                              </option>
                              <option value="sanctionDoneClaim">
                                Sanction done claim sub pending
                              </option>
                              <option value="sanctionDonePro">
                                Sanction done pro before reg
                              </option>
                              <option value="sanctionPending">
                                Sanction pending
                              </option>
                              <option value="sanctionPendingPro">
                                Sanction pending pro before reg
                              </option>
                            </select>
                            <button onClick={() => handleSaveStatus(value?.id)}>
                              <i className="bi bi-check2" />
                            </button>
                          </div>
                        </td> */}
                        {/* <td>
                          <div className="d-flex align-items-center gap-2">
                            <select
                              value={
                                selectValues[value?.id]?.status3 ||
                                value?.status3 ||
                                ""
                              }
                              onChange={(e) => {
                                handleSelectChange2(e, value?.id, "status3");
                              }}
                            >
                              <option value="">Select</option>
                              <option value="2ndStagePending">
                                2nd stage pending
                              </option>
                              <option value="claimUnderProcess">
                                Claim under process
                              </option>
                              <option value="sanctionDoneClaim">
                                Sanction done claim sub pending
                              </option>
                              <option value="sanctionDonePro">
                                Sanction done pro before reg
                              </option>
                              <option value="sanctionPending">
                                Sanction pending
                              </option>
                              <option value="sanctionPendingPro">
                                Sanction pending pro before reg
                              </option>
                            </select>
                            <button onClick={() => handleSaveStatus(value?.id)}>
                              <i className="bi bi-check2" />
                            </button>
                          </div>
                        </td> */}
                        {/* <td>
                          <div className="d-flex align-items-center gap-2">
                            <select
                              value={
                                selectValues[value?.id]?.officeProcess ||
                                value?.officeProcess ||
                                ""
                              }
                              onChange={(e) => {
                                handleSelectChange2(
                                  e,
                                  value?.id,
                                  "officeProcess"
                                );
                              }}
                            >
                              <option value="">Select</option>
                              <option value="bankClaimDone">
                                Bank claim done
                              </option>
                              <option value="dicClaimSubmitted">
                                Dic claim submitted
                              </option>
                              <option value="onlineClaimSubmitted">
                                Online claim submitted
                              </option>
                            </select>
                            <button onClick={() => handleSaveStatus(value?.id)}>
                              <i className="bi bi-check2" />
                            </button>
                          </div>
                        </td>
                        <td>
                          <div className="d-flex align-items-center gap-2">
                            <select
                              value={
                                selectValues[value?.id]?.dicSubStage ||
                                value?.dicSubStage ||
                                ""
                              }
                              onChange={(e) => {
                                handleSelectChange2(
                                  e,
                                  value?.id,
                                  "dicSubStage"
                                );
                              }}
                            >
                              <option value="">Select</option>
                              <option value="clerkProcess">
                                Clerk process
                              </option>
                              <option value="gmId">GM Id</option>
                              <option value="inspectorId">Inspector Id</option>
                              <option value="rmId">RM Id</option>
                            </select>
                            <button onClick={() => handleSaveStatus(value?.id)}>
                              <i className="bi bi-check2" />
                            </button>
                          </div>
                        </td> */}
                        {/* <td>
                          <div className="d-flex align-items-center gap-2">
                            <select
                              value={
                                selectValues[value?.id]?.powerSub ||
                                value?.powerSub ||
                                ""
                              }
                              onChange={(e) => {
                                handleSelectChange2(e, value?.id, "powerSub");
                              }}
                            >
                              <option value="">Select</option>
                              <option value="Yes">Yes</option>
                              <option value="No">No</option>
                            </select>
                            <button onClick={() => handleSaveStatus(value?.id)}>
                              <i className="bi bi-check2" />
                            </button>
                          </div>
                        </td> */}
                        <td>
                          <input
                            type="text"
                            value={
                              selectValues[value?.id]?.status ||
                              value?.status ||
                              ""
                            }
                            onChange={(e) => {
                              handleInputChange(e, value?.id, "status");
                            }}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                handleInputChange(e, value?.id, "status");
                                callApi(
                                  value?.id,
                                  selectValues[value?.id],
                                  "status"
                                );
                              }
                            }}
                          />
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <Modal show={isModalOpen} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Delete Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h5>Are you sure you want to delete the project ?</h5>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="default" onClick={handleCloseModal}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleDeleteProject}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ManageProject;
